var _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 37.042 37.042",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.521,
    cy: 18.521,
    rx: 17.767,
    ry: 17.767,
    fillOpacity: 0,
    stroke: "#fff",
    strokeWidth: 1.5079
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.981 9.277h1.5077v18.646h-1.5077z",
    color: "#000000",
    fillOpacity: 0,
    strokeWidth: 1.6208,
    style: {
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.98 8.4668a0.81046 0.81046 0 0 0-0.81055 0.81055v18.645a0.81046 0.81046 0 0 0 0.81055 0.81055h1.5078a0.81046 0.81046 0 0 0 0.81055-0.81055v-18.645a0.81046 0.81046 0 0 0-0.81055-0.81055z",
    color: "#000000",
    fill: "#fff",
    style: {
      InkscapeStroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.506 9.277h1.5077v18.646h-1.5077z",
    color: "#000000",
    fillOpacity: 0,
    strokeWidth: 1.6208,
    style: {
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.506 8.4668a0.81046 0.81046 0 0 0-0.81055 0.81055v18.645a0.81046 0.81046 0 0 0 0.81055 0.81055h1.5078a0.81046 0.81046 0 0 0 0.81055-0.81055v-18.645a0.81046 0.81046 0 0 0-0.81055-0.81055z",
    color: "#000000",
    fill: "#fff",
    style: {
      InkscapeStroke: "none"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.74f789607735ac6d377ce3728ebd60b5.svg";
export { ForwardRef as ReactComponent };